/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CurrencyMaskInputMode } from 'ngx-currency';

@Component({
    selector: 'app-toolkit-rilievo-tab-anagrafica-rilievo',
    templateUrl: './tab-anagrafica-rilievo.component.html',
})
export class ToolkitGestioneRilievoTabAnagraficaRilievoComponent implements OnInit {

    @Input() canEdit: boolean;
    @Input() formGroup: FormGroup;
    readonly natural = CurrencyMaskInputMode.NATURAL;
    constructor() {
        
    }

    ngOnInit() {
        if (this.canEdit === false) {
            this.formGroup.disable();
        }
    }

}
